import React, { useState } from 'react';
import BackButton from '../components/BackButton';

const Board = ({ onContinue, onBack }) => {
    const [selectedBoard, setSelectedBoard] = useState('cbse');

    const boards = [
        { id: 'cbse', title: 'CBSE', desc: 'Central Board of Secondary Education - National Level', icon: 'menu_book', color: 'primary' },
        { id: 'icse', title: 'ICSE / ISC', desc: 'Council for the Indian School Certificate Examinations', icon: 'school', color: 'blue' },
        { id: 'ap-board', title: 'Andhra Pradesh', desc: 'Board of Secondary Education, Andhra Pradesh (BSEAP)', icon: 'account_balance', color: 'orange' },
        { id: 'maharashtra-board', title: 'Maharashtra', desc: 'MSBSHSE - State Board of Secondary & Higher Secondary Education', icon: 'history_edu', color: 'purple' },
        { id: 'telangana-board', title: 'Telangana Board', desc: 'Telangana State Board of Intermediate Education (TSBIE)', icon: 'assured_workload', color: 'teal' },
        { id: 'karnataka-board', title: 'Karnataka Board', desc: 'KSEEB - Karnataka Secondary Education Examination Board', icon: 'auto_stories', color: 'indigo' },
    ];

    const getColorClass = (color) => {
        const classes = {
            primary: 'bg-primary-light/30 dark:bg-primary/10 text-primary',
            blue: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600',
            orange: 'bg-orange-50 dark:bg-orange-900/20 text-orange-600',
            purple: 'bg-purple-50 dark:bg-purple-900/20 text-purple-600',
            teal: 'bg-teal-50 dark:bg-teal-900/20 text-teal-600',
            indigo: 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600',
        };
        return classes[color] || classes.primary;
    };

    return (
        <div className="bg-background-light dark:bg-background-dark text-gray-800 dark:text-gray-100 min-h-screen flex flex-col font-sans antialiased transition-colors duration-300">
            <nav className="w-full bg-surface-light/90 dark:bg-surface-dark/90 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <div className="flex items-center gap-4">
                            <BackButton onClick={onBack} title="Go Back" />
                            <div className="flex items-center gap-2">
                                <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-green-500/30">
                                    H
                                </div>
                                <span className="font-display font-bold text-xl tracking-tight text-gray-900 dark:text-white">Himigo</span>
                            </div>
                        </div>
                        <div className="hidden md:flex items-center space-x-8">
                            <div className="flex items-center gap-2 px-4 py-1.5 bg-gray-50 dark:bg-gray-800 rounded-full border border-gray-100 dark:border-gray-700">
                                <div className="flex items-center gap-2">
                                    <span className="w-6 h-6 rounded-full bg-primary text-white text-[10px] flex items-center justify-center font-bold">1</span>
                                    <span className="text-xs font-semibold text-primary">Board</span>
                                </div>
                                <div className="w-4 h-px bg-gray-300 dark:bg-gray-600"></div>
                                <div className="flex items-center gap-2 opacity-50">
                                    <span className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-500 text-[10px] flex items-center justify-center font-bold">2</span>
                                    <span className="text-xs font-semibold">Grade</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <button className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                                <span className="material-symbols-outlined">help</span>
                            </button>
                            <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-300 cursor-pointer" onClick={() => document.documentElement.classList.toggle('dark')}>
                                <span className="material-symbols-outlined text-[20px]">dark_mode</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <main className="flex-grow flex items-center justify-center p-4 relative overflow-hidden py-12">
                <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px]"></div>

                <div className="w-full max-w-5xl z-10">
                    <div className="text-center mb-10">
                        <h1 className="font-display font-extrabold text-3xl md:text-4xl text-gray-900 dark:text-white mb-4">
                            Select Your Curriculum Board
                        </h1>
                        <p className="text-gray-500 dark:text-gray-400 text-lg max-w-2xl mx-auto">
                            Choose your educational board to access personalized study materials and curriculum-aligned courses.
                        </p>
                    </div>

                    <form className="space-y-10">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {boards.map((board) => (
                                <label key={board.id} className="relative cursor-pointer group">
                                    <input
                                        type="radio"
                                        name="board"
                                        className="peer sr-only"
                                        checked={selectedBoard === board.id}
                                        onChange={() => setSelectedBoard(board.id)}
                                    />
                                    <div className="h-full p-6 bg-surface-light dark:bg-surface-dark border-2 border-transparent rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 peer-checked:border-primary peer-checked:ring-4 peer-checked:ring-primary/10 flex flex-col items-center text-center gap-4 group-hover:-translate-y-1">
                                        <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mb-2 ${getColorClass(board.color)}`}>
                                            <span className="material-symbols-outlined text-4xl">{board.icon}</span>
                                        </div>
                                        <div>
                                            <h3 className="font-display font-bold text-xl text-gray-900 dark:text-white mb-1">{board.title}</h3>
                                            <p className="text-sm text-gray-500 dark:text-gray-400">{board.desc}</p>
                                        </div>
                                        <div className="absolute top-4 right-4 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center scale-0 peer-checked:scale-100 transition-transform duration-200">
                                            <span className="material-symbols-outlined text-sm font-bold">check</span>
                                        </div>
                                    </div>
                                </label>
                            ))}
                        </div>

                        <div className="flex flex-col items-center gap-6 mt-12">
                            <div className="flex items-center gap-3">
                                <input className="h-5 w-5 text-primary border-gray-300 rounded focus:ring-primary dark:bg-gray-700 dark:border-gray-600 cursor-pointer" id="remember-choice" type="checkbox" />
                                <label className="text-sm font-medium text-gray-600 dark:text-gray-400 cursor-pointer" htmlFor="remember-choice">Remember my selection for this device</label>
                            </div>
                            <button
                                onClick={onContinue}
                                className="group relative w-full max-w-md flex items-center justify-center py-4 px-8 border border-transparent rounded-2xl shadow-xl shadow-primary/20 text-base font-bold text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-primary/30 transition-all duration-300 hover:-translate-y-1"
                                type="button"
                            >
                                Continue to Grade Selection
                                <span className="material-symbols-outlined ml-2 transition-transform group-hover:translate-x-1">arrow_forward</span>
                            </button>
                        </div>
                    </form>
                </div>
            </main>

            <footer className="bg-surface-light dark:bg-surface-dark border-t border-gray-100 dark:border-gray-800 py-6">
                <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 dark:text-gray-400">
                    <p>© 2024 Himigo Learning Platform. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a className="hover:text-gray-900 dark:hover:text-white" href="#">Privacy Policy</a>
                        <a className="hover:text-gray-900 dark:hover:text-white" href="#">Terms of Service</a>
                        <a className="hover:text-gray-900 dark:hover:text-white" href="#">Support</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Board;
